import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Toolbar from './components/Toolbar';
import NetworkPanel from './components/NetworkPanel';
import Sidebar from './components/Sidebar';
import VersionDisplay from './components/VersionDisplay';
import './App.css';

function App() {
  const meta = useSelector((state) => state.networkUndo.present.meta);

  useEffect(() => {
    document.title = meta && 'title' in meta ? `${meta.title}` : 'Untitled';
  }, [meta]);

  return (
    <div className="App">
      <Toolbar />
      <Sidebar />
      <NetworkPanel />
      <VersionDisplay />
    </div>
  );
}

export default App;
